<template>
    <div ref="mapContainer" :style="{ height: mapHeight, width: '100%' }"></div>
  </template>
  
  <script>
  export default {
    props: {
      markers: {
        type: Array,
        required: true,
      },
      initialCenter: {
        type: Object,
        default: () => ({ lat: -17.392562, lng: -66.1613909 }),
      },
      initialZoom: {
        type: Number,
        default: 8,
      },
      mapHeight: {
        type: String,
        default: '900px',
      },
    },
    data() {
      return {
        map: null,
        markerInstances: [],
        currentInfoWindow: null,
      };
    },
    mounted() {
      this.initMap();
    },
    watch: {
      markers(newMarkers) {
        this.updateMarkers(newMarkers);
      },
    },
    methods: {
      initMap() {
        const mapOptions = {
          center: this.initialCenter,
          zoom: this.initialZoom,
        };
        this.map = new google.maps.Map(this.$refs.mapContainer, mapOptions);
        this.updateMarkers(this.markers);
      },
      updateMarkers(markers) {
        this.markerInstances.forEach(marker => {
          marker.setMap(null);
        });
        this.markerInstances = [];

        markers.forEach(marker => {
          const markerInstance = new google.maps.Marker({
            map: this.map,
            position: marker.position,
            title: marker.title,
          });

          const infoWindow = new google.maps.InfoWindow({
            content: this.changeContent(marker),
            ariaLabel: marker.title,
          });

          markerInstance.addListener('click', () => {
            if (this.currentInfoWindow) {
              this.currentInfoWindow.close();
            }
            infoWindow.open(this.map, markerInstance);
            this.currentInfoWindow = infoWindow;
          });

          this.markerInstances.push(markerInstance);
        });
      },
      changeContent(marker){
        let content = `
          <div>
            <h3 style="padding-right: 1rem">${marker.alias || ''}</h3>
          </div>
        `
        return content;
      }
    },
  };
  </script>
  
  <style scoped>
  </style>
  